import React, { useEffect, useRef, useState } from 'react';
import styles from '../addCategoryForm/addCategoryForm.module.css';
import { Close, Closecircle, closeCircle, UploadImg } from '../../Svg';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import stylesp from './prod.module.css';
import { exportAtributeThunk } from '../../redux/atributes/getAllAtributes';


const AddLevelForm = () => {

    const thumbnailImageref = useRef()
    const [loading, setLoading] = useState(false)
    const coverImageRef = useRef(null);
    const [isCoverUploadloading, setCoverUploading] = useState(false)
    const [categoryId, setCategoryId] = useState('')
    const [isOpen, setIsOpen] = useState(false);
    const { exportedData } = useSelector((state) => state.atributes);

    const { categoryHeirarchy } = useSelector((state) => state.categoryHeirarchy);
    const categories = categoryHeirarchy?.categories
    const subcategory = categoryHeirarchy?.subcategories
    const dispatch = useDispatch()
    const [filteredData, setFilteredData] = useState(null);
    const [filteredSubcategory, setFiilteredSubcategory] = useState([])

    const navigate = useNavigate()

    const [searchTerm, setSearchTerm] = useState('');
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                closeDropdown();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const closeDropdown = () => {
        setIsOpen(false);
        setSearchTerm('');
        setFilteredData(null);
    };

    const handleToggleDropdown = () => {
        const newState = !isOpen;
        setIsOpen(newState);
        if (!newState) {
            closeDropdown();
        }
    };

    const handleSearchChange = (e) => {
        const term = e.target.value;
        setSearchTerm(term);
        const filtered = term === ''
            ? null
            : exportedData?.data?.filter(customer =>
                customer?.variant_name?.toLowerCase().includes(term.toLowerCase())
            );
        setFilteredData(filtered);
    };

    // console.log(exportedData);


    // Define the Formik schema
    const {
        errors,
        values,
        handleChange,
        touched,
        setFieldValue,
        isSubmitting,
        handleBlur,
        handleSubmit,
        resetForm
    } = useFormik({
        initialValues: {
            name: '',
            cover_image: null,
            thumbnail: {
                photo: null,
                status: ''
            },
            parentId: '',
            atributes: []
        },
        enableReinitialize: true,
        validationSchema: Yup.object({
            name: Yup.string().required('Level 3 Category name is required'),
            parentId: Yup.string().required(' Subcategory name is required'),
            thumbnail: Yup.object().shape({
                status: Yup.string().required('Status is required'),
            }),
        }),
        onSubmit: async (values) => {

            try {
                const { data, status } = await api.addLevel3Category(values)
                if (status == 200) {
                    console.log(data);
                    toast.success(data?.data?.message)
                    navigate(-1)
                }
            } catch (err) {
                console.log(err);
                toast.error(err?.response?.data?.message || 'something went wrong')
            }

        },
    });


    useEffect(() => {
        dispatch(exportAtributeThunk())
    }, [])

    const handleImageChange = async (e, attribute, repo) => {

        const file = e.target?.files?.[0] || e.dataTransfer?.files?.[0];
        if (repo == "photo") {
            setLoading(true)
        } else {
            setCoverUploading(true)
        }

        try {
            if (file) {
                const body = new FormData()
                body.append('image', file)
                body.append("repo", `category/${repo}`)

                const { data, status } = await api.fileUpload(body)

                if (status === 200) {
                    setFieldValue(attribute, data.data)
                }
            }
        } catch (err) {
            console.log(err);
            toast.error("Error uploading file")
        } finally {
            if (repo == "photo") {
                setLoading(false)
            } else {
                setCoverUploading(false)
            }
        }
    };


    useEffect(() => {
        if (categoryId) {

            if (subcategory?.length > 0) {
                const filteredSubcategory = subcategory?.filter(i => i?.parentId?.includes(categoryId))
                setFiilteredSubcategory(filteredSubcategory)
            }
        }
    }, [categoryId])

    const handleRemove = (repo) => {
        setFieldValue(repo, "")
    }

    const handleSelectionChange = (manufacturerId) => {
        const { atributes } = values;
        if (atributes?.includes(manufacturerId)) {
            setFieldValue(
                "atributes",
                atributes?.filter(id => id !== manufacturerId)
            );
        } else {
            setFieldValue(
                "atributes",
                [...atributes, manufacturerId]
            );
        }
    };

    return (
        <>
            <form onSubmit={handleSubmit} className={styles.updateCategoryContainer}>
                <div className={styles.genaralInfo}>
                    <div className={styles.formSection}>
                        <div className={styles.card}>
                            <h2 className={styles.addCatH2}>General Information</h2>
                            <label className={styles.addCatLabel}>
                                Category Name*
                                <select
                                    className={styles.addCatSelect}
                                    onChange={(e) => setCategoryId(e.target.value)}
                                >
                                    <option value="" >select</option>
                                    {categories?.length > 0 ?
                                        <>
                                            {categories?.map(category => (
                                                <option key={category._id} value={category._id}>
                                                    {category.name}
                                                </option>
                                            ))}

                                        </>
                                        :
                                        <option value="" disabled>no categories found</option>
                                    }
                                </select>

                            </label>
                            <label className={styles.addCatLabel}>
                                Subcategory Name*
                                <select
                                    name='parentId'
                                    className={styles.addCatSelect}
                                    value={values.parentId}
                                    onChange={handleChange}
                                    onBlur={handleBlur}>
                                    <option value="">Select</option>
                                    {filteredSubcategory?.length > 0 ?
                                        <>
                                            {filteredSubcategory?.map(subcategory => (
                                                <option key={subcategory._id} value={subcategory._id}>
                                                    {subcategory.name}
                                                </option>
                                            ))}

                                        </>
                                        :
                                        <option value="" disabled>no categories found</option>
                                    }
                                </select>
                                {touched.parentId && errors.parentId ? (
                                    <div className={styles.errorText}>{errors.parentId}</div>
                                ) : null}
                            </label>
                            <label className={styles.addCatLabel}>
                                Subcategory level 3*
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Type category name here..."
                                    className={styles.addCatInput}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.name}
                                />
                                {touched.name && errors.name ? (
                                    <div className={styles.errorText}>{errors.name}</div>
                                ) : null}
                            </label>

                            {/*  <div className={styles.imageUpload}>
                                <p className={styles.addCatLabel}>Cover Image</p>
                                {isCoverUploadloading ? <div className={styles.uploadBox}>Please wait...</div> :
                                    <>

                                        {
                                            values.cover_image
                                                ? <div className={styles.uploadBox} style={{ display: 'flex', justifyContent: 'center' }}>
                                                    <img src={values.cover_image[0]} alt="" className={styles.previewImage} />
                                                    <div className={styles.cancel_cross} onClick={() => handleRemove("cover_image")}>
                                                        {closeCircle()}
                                                    </div>
                                                </div>
                                                :

                                                <div
                                                    className={styles.uploadBox}
                                                    onClick={() => coverImageRef.current.click()}
                                                    onDrop={(e) => { e.preventDefault(); handleImageChange(e, "cover_image", "cover_image"); }}
                                                    onDragOver={(e) => e.preventDefault()}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <span className={styles.uploadIcon}><UploadImg /></span>
                                                    <p className={styles.addCatPara}>Drag and drop image here, or click to add image</p>
                                                    <input
                                                        type="file"
                                                        style={{ display: 'none' }}
                                                        ref={coverImageRef}
                                                        onChange={(e) => handleImageChange(e, "cover_image", "cover_image")}
                                                        accept="image/*"

                                                    />
                                                </div>
                                        }
                                    </>
                                }
                            </div> */}

                            <div style={{ paddingBottom: '10px', display: "block", marginTop: 10 }} className={styles.addCatLabel}>
                                Key features/attributes for exact match
                                <div style={{ position: 'relative' }} ref={dropdownRef}>
                                    <div
                                        className={styles.addCatSelect}
                                        onClick={handleToggleDropdown}
                                    >
                                        Select
                                    </div>

                                    {isOpen &&
                                        <div className={stylesp.dropdownContent}>
                                            <div style={{}}>
                                                <input
                                                    type="text"
                                                    placeholder="Search..."
                                                    style={{
                                                        width: '100%',
                                                        padding: '10px',
                                                        boxSizing: 'border-box',
                                                        border: '1px solid #ccc',
                                                        borderRadius: '4px'
                                                    }}
                                                    value={searchTerm}
                                                    onChange={handleSearchChange}
                                                />
                                            </div>

                                            <div style={{ maxHeight: "140px", overflowY: "scroll" }}>
                                                {(filteredData || exportedData?.data)?.map((customer) => (
                                                    <label
                                                        key={customer?._id}
                                                        className={stylesp.dropdownItem}
                                                    >
                                                        {customer?.variant_name}
                                                        <input
                                                            type="checkbox"
                                                            checked={values?.atributes?.includes(customer?.variant_name)}
                                                            onChange={() => handleSelectionChange(customer?.variant_name)}
                                                        />
                                                    </label>
                                                ))}
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: "center", width: "100%" }}>
                                                <button
                                                    type="submit"
                                                    className={stylesp.loginButton}
                                                    style={{ borderRadius: "0px" }}
                                                    onClick={() => setIsOpen(false)}
                                                >
                                                    Submit
                                                </button>
                                            </div>
                                        </div>
                                    }
                                </div>
                                {values?.atributes?.map((i, index) => {
                                    // The master attribute may have been deleted after this
                                    // selection was saved. Use the stored name as a fallback.
                                    const manufacturer = exportedData?.data?.find((item) => item?.variant_name === i);
                                    const attributeName = manufacturer?.variant_name || i;
                                    if (!attributeName) return null;
                                    return (
                                        <div key={`${attributeName}-${index}`} className={styles.dropdownresult}>
                                            {attributeName} <div onClick={() => handleSelectionChange(attributeName)}><Closecircle /></div>
                                        </div>
                                    )
                                })

                                }

                            </div>
                            {/* </div> */}
                        </div>
                    </div>
                    <div className={styles.buttonGroup}>
                        <button type="button" className={styles.cancelButton} onClick={() => resetForm()}><Close />Cancel</button>
                        <button type="submit" className={styles.updateButton} disabled={isSubmitting}>{isSubmitting ? 'please wait' : "Add Level3"}</button>
                    </div>
                </div>

                <div className={styles.thumbnain}>
                    {/*   <div className={styles.card}> */}
                    {/*  <h2 className={styles.addCatH2}>Thumbnail</h2>
                        <p style={{ fontSize: '14px', color: '#777980', padding: '20px 0px 6px 0px' }}>Photo</p>
                        {loading ? <div className={styles.uploadBox}>please wait...</div> :
                            <>
                                {
                                    values.thumbnail.photo
                                        ? <div className={styles.uploadBox} style={{ display: 'flex', justifyContent: 'center' }}>
                                            <img src={values.thumbnail.photo[0]} alt="" className={styles.previewImage} />
                                            <div className={styles.cancel_cross} onClick={() => handleRemove("thumbnail.photo")}>
                                                {closeCircle()}
                                            </div>
                                        </div>
                                        :
                                        <div className={styles.uploadBox}
                                            onClick={() => thumbnailImageref.current.click()}
                                            onDrop={(e) => { e.preventDefault(); handleImageChange(e, 'thumbnail.photo', 'photo'); }}
                                            onDragOver={(e) => e.preventDefault()}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <span className={styles.uploadIcon}>
                                                <UploadImg />
                                            </span>
                                            <p className={styles.addCatPara}>Drag and drop image here, or click add image</p>
                                            <button type="button" className={styles.addImgBtn} >Add Image</button>
                                            <input type="file" name="" id=""
                                                ref={thumbnailImageref}
                                                style={{ display: 'none' }}
                                                onChange={(e) => handleImageChange(e, 'thumbnail.photo', 'photo')}
                                                accept="image/*"
                                            />

                                        </div>
                                }
                            </>
                        } */}
                    <div className={styles.card}>
                        <h2 className={styles.addCatH2}> Status</h2>
                        <label>
                            Category Status*
                            <select
                                name="thumbnail.status"
                                className={styles.addCatSelect}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.thumbnail.status}
                            >
                                <option value="">Select...</option>
                                <option value="ACTIVE">Active</option>
                                <option value="INACTIVE">Inactive</option>
                            </select>
                            {touched.thumbnail?.status && errors.thumbnail?.status && (
                                <div className={styles.errorText}>{errors.thumbnail.status}</div>
                            )}
                        </label>
                    </div>
                    {/*  </div> */}
                </div>

            </form>
        </>
    );
};

export default AddLevelForm;
